import { render, staticRenderFns } from "./redistribute.vue?vue&type=template&id=52ec0b86&scoped=true"
import script from "./redistribute.vue?vue&type=script&lang=js"
export * from "./redistribute.vue?vue&type=script&lang=js"
import style0 from "./redistribute.vue?vue&type=style&index=0&id=52ec0b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec0b86",
  null
  
)

export default component.exports